import React, { useState } from "react";

import {
  Accordion,
  AccordionDetails,
  Box,
  Divider,
  Link,
  Theme,
  useMediaQuery,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

import { SequencingEstimator } from "components/PanelDetailContent/components/SequencingEstimator";
import useCatalogDetail from "hooks/useCatalogDetail";
import { colors } from "theme";
import { DesignType, IDesign, Workflow } from "types/design";

import { KeyMetricsItem } from "./KeyMetricItem";
import { IKeyMetricsItem } from "./type";

const Metrics: IKeyMetricsItem[] = [
  {
    key: "numberGenes",
    title: "Genes",
  },
  {
    key: "totalBases",
    title: "Total Bases",
  },
  {
    key: "readsRecommended",
    title: "Reads Recommended",
  },
  {
    key: "numberPrimerPairs",
    title: "GSP2 Primers",
  },
];

export const KeyMetrics = () => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);
  let { catalog, workflow } = useCatalogDetail();
  const inNarrowMode = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('sm')
  );

  catalog = catalog as IDesign;

  if (!catalog) {
    return <></>;
  }

  const toggleSequencingEstimator = (event: React.UIEvent) => {
    setExpanded(!expanded);
    event.stopPropagation();
    event.preventDefault();
  };

  return (
    <Accordion expanded={expanded}>
      <Box
        id="key-metrics"
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }}
        flexWrap="wrap"
        bgcolor={colors.white}
        padding={2}
        borderRadius="4px"
        gap={inNarrowMode ? "16px" : 0}
      >
        {Metrics.map((metric: IKeyMetricsItem, index: number) => (
          <React.Fragment key={metric.title}>
            <Box flexGrow={1} flexBasis={0}>
              <KeyMetricsItem
                amount={catalog?.[metric.key] as string | number}
                {...metric}
                extraContent={
                  metric.key === "readsRecommended" &&
                  catalog?.designType !== DesignType.GENE_MODULE ? (
                    <Link
                      color="secondary"
                      underline="always"
                      tabIndex={0}
                      onClick={toggleSequencingEstimator}
                      component="button"
                      className={classes.sequencingEstimatorLink}
                    >
                      Sequencing Estimator
                    </Link>
                  ) : null
                }
              />
            </Box>
            {index < Metrics.length - 1 && (
              <Divider
                orientation={inNarrowMode ? "horizontal" : "vertical"}
                flexItem={inNarrowMode ? false : true}
                className={classes.divider}
              />
            )}
          </React.Fragment>
        ))}
      </Box>

      {catalog?.designType !== DesignType.GENE_MODULE &&
        !!workflow &&
        expanded && (
          <AccordionDetails className={classes.accordionDetails}>
            <SequencingEstimator
              reads={catalog.readsRounded}
              onClose={() => setExpanded(false)}
              showAll={workflow?.name === Workflow.FUSION}
            />
          </AccordionDetails>
        )}
    </Accordion>
  );
};

const useStyles = makeStyles({
  divider: {
    backgroundColor: colors.grey[400],
  },
  accordionDetails: {
    padding: 0,
  },
  sequencingEstimatorLink: {
    textAlign: "left",
    fontSize: 14,
    lineHeight: "22px",
    letterSpacing: 0.5,
  },
});
